import axios from 'axios';

const apiClient = axios.create({
  // baseURL: 'http://localhost:8080/api/v1',   // point to your API
  baseURL: 'https://api.daily-meal.com/api/v1',   // point to your API
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': localStorage.getItem('language') || 'en',
    accept: '*/*'
  }
});

// inject auth token on every request
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// optional: handle global 401 here
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // e.g. redirect to login
    }
    return Promise.reject(error);
  }
);

export default apiClient;